import { Injectable } from '@angular/core';
import { KeycloakInstance } from 'keycloak-js';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { RestApiService } from './rest-api.service';
import { UserSymfony } from '../interfaces/user-symfony';
import { Location } from "@angular/common";
import { Router } from '@angular/router';
import { OtpService } from './api/otp.service';
import { UserService } from './user.service';

declare var Keycloak: any;

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

    public userIdentity: KeycloakInstance = {} as KeycloakInstance;

    constructor(private userService: UserService, 
                private location: Location,
                public apiService: RestApiService) { }

    async init(): Promise<any> {

        const exceptionsPatterns = [
            "open\/client\/(.*)",
            "\/open\/client\/message\/(.*)",
            "revokeConsent\/(.*)",
            "\/respond\/client\/message\/(.*)"
        ];

        if (this.location.path().match("(?:" + exceptionsPatterns.join('|') + ")") == null) {

            this.userIdentity = new Keycloak({
                url: environment.KeycloakConfig.url,
                realm: environment.KeycloakConfig.realm,
                clientId: environment.KeycloakConfig.clientId
            });

            await this.userIdentity.init({
                /**
                 * login-required: L'utilisateur s'authentifie immédiatmeent
                 * check-sso : L'utilisateur n'a pas besoin d'être authentifié initialement
                 */
                onLoad: 'check-sso',
                /**
                 * Set to enable/disable monitoring login state (default is true).
                 */
                checkLoginIframe: false,
                /**
                 * Set the interval to check login state (default is 5 seconds).
                 */
                // checkLoginIframeInterval
                /**
                 * Adds a cryptographic nonce to verify that the authentication response matches the request (default is true).
                 */
                // seNonce: true
                /**
                 * Set the redirect uri for silent authentication check if onLoad is set to 'check-sso'.
                 */
                // silentCheckSsoRedirectUri
                /**
                 * Enables fall back to regular check-sso when silent check-sso is not supported by the browser (default is true).
                 */
                // silentCheckSsoFallback
                /**
                 * Set an initial value for the token.
                 */
                // token
                /**
                 * Set an initial value for the refresh token.
                 */
                // refreshToken
                /**
                 * Set an initial value for the id token (only together with token or refreshToken).
                 */
                // idToken
                /**
                 * Set an initial value for skew between local time and Keycloak server in seconds (only together with token or refreshToken).
                 */
                // timeSkew
                /**
                 * Set the OpenID Connect response mode send to Keycloak server at login request.
                 * Valid values are query or fragment.
                 * Default value is fragment, which means that after successful authentication will Keycloak
                 * redirect to JavaScript application with OpenID Connect parameters added in URL fragment.
                 * This is generally safer and recommended over query.
                 */
                // responseMode
                /**
                 * Set the OpenID Connect flow. Valid values are standard, implicit or hybrid.
                 */
                // flow
                /**
                 * Enables logging messages from Keycloak to the console (default is false).
                 */
                // enableLogging
                /**
                 * The method for Proof Key Code Exchange (PKCE) to use.
                 * Configuring this value enables the PKCE mechanism. Available options: "S256" - The SHA256 based PKCE method
                 */
                // pkceMethod
            });

            // User instanciation
            await this.userService.init(this.userIdentity);
        } else {

            var ref = null;
            exceptionsPatterns.forEach(regex => {
                var res = this.location.path().match(regex);
                if (res) {
                    ref = res[1];
                }
            });

            if (ref) {
                const auth_response = await this.apiService.authClient(ref);
                if (auth_response.result == "SUCCESS") {
                    this.userService.currentUser.openMessage = true;
                    this.userService.currentUser.ps = auth_response.content.ps;
                    this.userService.currentUser.template = auth_response.content.template;
                } else {

                }
            }
        }
    }
}
